import type { ExpertAssistMessage } from "../../shared-types";

import { Feedback } from "../feedback-loader";
import { QuickActionGroup, type QuickActionGroupProps } from "../quick-actions";

interface MessageActionsProps {
    isQuickActionsVisible: boolean;
    quickActionGroupProps: QuickActionGroupProps;
    shouldShowFeedback: boolean;
    message?: ExpertAssistMessage;
}

export function MessageActions({
    isQuickActionsVisible,
    quickActionGroupProps,
    shouldShowFeedback,
    message,
}: MessageActionsProps) {
    return (
        <>
            {isQuickActionsVisible && <QuickActionGroup {...quickActionGroupProps} />}
            {shouldShowFeedback && <Feedback message={message} />}
        </>
    );
}
